import ModelWrapperV1 from "./ModelWrapper/v1";
import OverlayV1 from "./Overlay/v1";
import ModelHeaderV1 from "./ModelHeader/v1";
import ModelContentV1 from "./ModelContent/v1";
import ModelContainerV1 from "./ModelContainer/v1";
import { withVersions } from "v2/hocs/withVersions";
import { withModelWrapper } from "../hocs/withModelWrapper";
import { withModelContainer } from "../hocs/withModelContainer";

const ModelHeader = {
  Wrapper: withVersions({
    v1: ModelHeaderV1.Wrapper,
    v2: ModelHeaderV1.Wrapper,
  }),
  Title: withVersions({
    v1: ModelHeaderV1.Title,
    v2: ModelHeaderV1.Title,
  }),
  CloseButton: withVersions({
    v1: ModelHeaderV1.CloseButton,
    v2: ModelHeaderV1.CloseButton,
  }),
};

const ModelContent = withVersions({
  v1: ModelContentV1,
  v2: ModelContentV1,
});

const ModelWrapper = withVersions({
  v1: withModelWrapper(ModelWrapperV1, OverlayV1),
  v2: withModelWrapper(ModelWrapperV1, OverlayV1),
});

const ModelContainer = withVersions({
  v1: withModelContainer(ModelContainerV1),
  v2: withModelContainer(ModelContainerV1),
});

const Model = {
  Wrapper: ModelWrapper,
  Header: ModelHeader,
  Content: ModelContent,
  Container: ModelContainer,
};

export default Model;
